/**
 * deprecate
 *
 * handles deprecation warnings in development
 */
export default (warning: string): void => {
	console.warn(warning)
}
